<template>
  <svg baseProfile="full"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:ev="http://www.w3.org/2001/xml-events"
    x="0" y="0" :width="size.width" :height="size.height"
    overflow="visible">
    <svg x="0" y="0" width="100%" height="100%" viewBox="0 0 42 42" preserveAspectRatio="xMidYMid" overflow="visible">
      <circle cx="21" cy="21" r="21" fill="none" stroke="#BCCCDC"></circle>
    </svg>
    <svg x="33%" y="33%" width="33%" height="33%">
      <slot />
    </svg>
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Object,
      default: () => {
        return {
          width: '60px',
          height: '60px'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
